<template>
    <div class="content-strategy-modal blog-modal">
        <div class="blog-modal__modal import-modal">
            <button class="btn-link social-modal__exit btn-hover" @click.prevent="onClose()">
                <i class="fas fa-times"></i>Close
            </button>
            <div class="import-modal__wrap">
                <h1>Create This</h1>

                <div class="modal-content">
                    <div class="modal-content-wrap">

                        <!-- Title Field -->
                        <div class="modal-row" :class="{'has-error': formSubmitted && !fieldValue('title', 'title')}">
                            <div class="modal-col-header">Title <span class="asterisk">*</span></div>
                            <div class="modal-col-text form-item">
                                <!--<input type="text" 
                                    v-model="node.fieldGroups.title.fields.title.value" 
                                    placeholder="Enter title here" 
                                    :class="{'input-error': formSubmitted && !node.fieldGroups.title.fields.title.value}"
                                    :key="'nodeTitle'" 
                                    :id="'nodeTitle'"
                                    :name="'nodeTitle'"
                                    :isRequired="true"
                                    >-->
                                    <TextField
                                    :key="'nodeTitle'" 
                                    :fieldId="'nodeTitle'"
                                    :fieldPlaceholder="'Enter title here*'" 
                                    :isRequired="true" 
                                    :valueProp="fieldValue('title', 'title')" 
                                    @fieldUpdated="(value) => updateFieldValue($event, 'title', 'title', value)"
                                    ></TextField>
                                    <button class="add-node-form-ai-btn ai-generate-icon" @click.prevent="this.$store.commit('client/setAIPopUpFields', {prop: 'modals/titleField', val: true})" ><i class="fa-solid fa-wand-magic-sparkles"></i></button>
                            </div>
                        </div>

                        <div class="modal-row large-margin-bottom">
                            <div class="modal-col-header">Details</div>
                            <div class="modal-col-text form-item">
                                <!--<textarea v-model="node.fieldGroups.details.fields.details.value" placeholder="Enter details here"></textarea>-->
                                <Textarea
                                v-model="node.fieldGroups.details.fields.details.value" 
                                :fieldId="'details'" 
                                :fieldPlaceholder="'Enter details here'" 
                                :isRequired="false"
                                :valueProp="fieldValue('details', 'details')" 
                                @fieldUpdated="(value) => updateFieldValue($event, 'details', 'details', value)"
                                ></Textarea>
                                <button class="add-node-form-ai-btn ai-generate-icon" @click.prevent="this.$store.commit('client/setAIPopUpFields', {prop: 'modals/detailsField', val: true})" ><i class="fa-solid fa-wand-magic-sparkles"></i></button>
                            </div>
                        </div>

                        <div class="modal-row">
                            <div class="modal-col-header">Assign</div>
                            <div class="modal-col-text">
                                <div class="styled-select">
                                    <VueNextSelect 
                                    :key="selectKey" 
                                    v-model="node.fieldGroups.assign.fields.assign.value" 
                                    :options="getClientUsers" 
                                    label-by="username" 
                                    close-on-select
                                    />
                                </div>   
                            </div>
                        </div>

                        <div class="modal-row">
                            <div class="modal-col-header">Deadline</div>
                            <div class="modal-col-text">
                            	<div class="deadline form-item datepicker">
                                    <Datepicker v-model="node.fieldGroups.deadline.fields.deadline.value" class="form-control" dark autoApply format="dd/MM/yyyy HH:mm"></Datepicker>
                                </div>
                            </div>
                        </div>

                        <div class="modal-row">
                            <div class="modal-col-header">Keyword</div>
                            <div class="modal-col-text">
                                <!--<input type="text" 
                                    v-model="node.fieldGroups.keyword.fields.keyword.value" 
                                    placeholder="Enter keyword here">-->
                                <TextField 
                                v-model="node.fieldGroups.keyword.fields.keyword.value"
                                :fieldId="'keyword'"
                                :fieldPlaceholder="'Enter keyword here'" 
                                :isRequired="false" 
                                :valueProp="fieldValue('keyword', 'keyword')" 
                                @fieldUpdated="(value) => updateFieldValue($event, 'keyword', 'keyword', value)"
                                ></TextField> 
                                <button class="access-keyword-planner-btn" @click.prevent="onOpenKeywordPlannerModal">Keyword Planner</button>
                            </div>
                        </div>

                        <!-- Format Field -->
                        <div class="modal-row" :class="{'has-error': formSubmitted && !node.fieldGroups.format.fields.format.value}">
                            <div class="modal-col-header">Format <span class="asterisk">*</span></div>
                            <div class="modal-col-text">
                                <div class="styled-select">
                                    <VueNextSelect 
                                        :key="selectKey1" 
                                        v-model="node.fieldGroups.format.fields.format.value" 
                                        :options="formats" 
                                        label-by="format" 
                                        close-on-select
                                        :class="{'input-error': formSubmitted && !node.fieldGroups.format.fields.format.value}"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="modal-row">
                            <div class="modal-col-header">Intent</div>
                            <div class="modal-col-text">
                                <input type="text" v-model="node.fieldGroups.intent.fields.intent.value" placeholder="Enter intent here">
                            </div>
                        </div>

                        <div class="modal-row">
                            <div class="modal-col-header">Research</div>
                            <div class="modal-col-text">
                                <input type="text" v-model="node.fieldGroups.research.fields.research.value" placeholder="Enter research here">
                            </div>
                        </div>

                        <!-- Status Field -->
                        <!-- <div class="modal-row" :class="{'has-error': formSubmitted && !node.fieldGroups.status.fields.status.value}">
                            <div class="modal-col-header">Status*</div>
                            <div class="modal-col-text">
                                <div class="styled-select">
                                    <VueNextSelect 
                                        :key="selectKey" 
                                        v-model="node.fieldGroups.status.fields.status.value" 
                                        :options="statusOptions" 
                                        label-by="status" 
                                        close-on-select
                                        :class="{'input-error': formSubmitted && !node.fieldGroups.status.fields.status.value}"
                                    />
                                </div>
                            </div>
                        </div> -->

                        <div class="modal-row">
                            <div class="modal-col-header">Author</div>
                            <div class="modal-col-text">
                                <div class="styled-select">
                                    <VueNextSelect 
                                        :key="selectKey" 
                                        v-model="node.fieldGroups.author.fields.author.value" 
                                        :options="getClientUsers" 
                                        label-by="username" 
                                        close-on-select
                                    />
                                </div> 
                            </div>
                        </div>
                        <div class="modal-row">
                            <div class="modal-col-header">Created</div>
                            <div class="modal-col-text">
                                <div class="deadline form-item datepicker">
                                    <Datepicker v-model="node.fieldGroups.created.fields.created.value" class="form-control" dark autoApply format="dd/MM/yyyy HH:mm"></Datepicker>
                                </div>
                            </div>
                        </div> -->

                    </div>
                </div>

                <div class="btn-row">
                    <div class="content-strategy-error-modal"  v-if="errorMessage">
                        <h3>{{ errorMessage }}</h3>
                    </div>
                    <button class="btn-save" @click.prevent="handleSubmit()">
                        <i class="fa-solid fa-circle-check"></i>Create
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueNextSelect from 'vue-next-select';
import Datepicker from "vue3-date-time-picker";
import Node from '../../services/contentNodes';
import TextField from "../forms/inputs/TextField.vue";
import Textarea from "../forms/inputs/Textarea.vue";
import { mapState } from "vuex";

export default {
    components: {
        VueNextSelect,
        Datepicker, // Register the date picker component
        TextField,
        Textarea,
    },
    data() {
        return {
            formats: [{format: 'Blog'}, {format: 'Social'}],
            statusOptions: [
                {status: 'Title Created'},
                {status: 'Assigned'},
                {status: 'Pending review'},
                {status: 'Approved'},
                {status: 'Rejected'},
                {status: 'Published'},
                {status: 'Archived'},
            ],
            selectKey: 0,
            selectKey1: 0,
            node: new Node(),
            formSubmitted: false, // Add this flag to handle validation
            errorMessage: ''
        };
    },
    computed: {
        fieldValue() {
			return (fieldGroup, fieldTitle) => {
				return this.$store.getters["client/getNodeFieldValue"](fieldGroup, fieldTitle)
			}
		},
        ...mapState({
            getKeywordValue: state => state.client.currentNode.fieldGroups.keyword.fields.keyword.value
        }),
        ...mapGetters("client", ["getContentStrategy", "getClientUsers", "getClientData", "getCurrentNode", "getOpenKeywordPlannerModal"]),
        ...mapGetters("auth", ["getAuthData", "getAuthRoleName"]),
    },
    watch:{
        'node.fieldGroups': {
            async handler(val) {
                console.log('changedddd', val);
            },
            deep: true
        },
        'getCurrentNode.fieldGroups.title.fields.title.value': {
            async handler(val) {
                console.log('TITLE value changed HELLO', val);
       
            },
            deep: true
        },
    },
    state: {
        openKeywordPlannerModal: false,
    },
    mutations: {
        updateNodeFieldValue(state, { fieldGroup, field, value }) {
            console.log('fieldgroup1', fieldGroup);
            console.log('updated value test', value);
            if (
                state.node &&
                state.node.fieldGroups &&
                state.node.fieldGroups[fieldGroup] &&
                state.node.fieldGroups[fieldGroup].fields &&
                state.node.fieldGroups[fieldGroup].fields[field]
            ) {
                // Ensure Vue detects change
                state.node.fieldGroups[fieldGroup].fields[field].value = value;
            } else {
                console.error("Invalid field path:", fieldGroup, field);
            }
        },
        setOpenKeywordPlannerModal(state, value) {
            state.openKeywordPlannerModal = value;
        },
        resetNodeFields(state) {
            state.node.fieldGroups.title.fields.title.value = "";
            state.node.fieldGroups.details.fields.details.value = "";
            state.node.fieldGroups.keyword.fields.keyword.value = "";
        }
    },
    mounted(){

        console.log('TEST', this.getCurrentNode.fieldGroups.title.fields.title.value);
        this.node.fieldGroups.status.fields.status.value = 'Title Created';
        this.node.fieldGroups.title.fields.title.value = '';
        this.node.fieldGroups.details.fields.details.value = '';

        if(this.getContentStrategy.isDayView){
            console.log('=== is viewing day ====', [this.getContentStrategy.isDayView, this.getContentStrategy.exactDate]);
            this.node.fieldGroups.deadline.fields.deadline.value = this.getContentStrategy.exactDate;
        }else{
            const month = this.getContentStrategy.month; // e.g., 'september'
            const year = this.getContentStrategy.year; // e.g., '2024'
            // Create a map for month names to month numbers (0-based index in JavaScript Date object)
            const monthMap = {
                january: 0,
                february: 1,
                march: 2,
                april: 3,
                may: 4,
                june: 5,
                july: 6,
                august: 7,
                september: 8,
                october: 9,
                november: 10,
                december: 11
            };
            // Get the corresponding month number from the month name
            const monthNumber = monthMap[month.toLowerCase()];
            // Create the date object for the 1st day of the given month and year
            const dateObj = new Date(year, monthNumber, 1);
            this.node.fieldGroups.deadline.fields.deadline.value = dateObj;
        }
        console.log('=== DEADLINE HAS BEEN UPDATED ====', this.node.fieldGroups.deadline.fields.deadline.value)
        console.log('the status is!', this.node.fieldGroups.status.fields.status.value);
    },
    methods: {
        mapSelectFields(){
            console.log('mapSelectedFields', this.node.fieldGroups);
            if(this.node.fieldGroups.status.fields.status.value && this.node.fieldGroups.status.fields.status.value.status){
                this.node.fieldGroups.status.fields.status.value = this.node.fieldGroups.status.fields.status.value.status;
            }else{
                this.node.fieldGroups.status.fields.status.value = ''
            }
            if(this.node.fieldGroups.format.fields.format.value && this.node.fieldGroups.format.fields.format.value.format){
                this.node.fieldGroups.format.fields.format.value = this.node.fieldGroups.format.fields.format.value.format;
            }else{
                this.node.fieldGroups.format.fields.format.value = ''
            }
            if(this.node.fieldGroups.author.fields.author.value && this.node.fieldGroups.author.fields.author.value.username){
                this.node.fieldGroups.author.fields.author.value =  this.node.fieldGroups.author.fields.author.value.username
            }else{
                this.node.fieldGroups.author.fields.author.value = ''
            }
            if(this.node.fieldGroups.assign.fields.assign.value && this.node.fieldGroups.assign.fields.assign.value.username){
                this.node.fieldGroups.assign.fields.assign.value = this.node.fieldGroups.assign.fields.assign.value.username;
            }else{
                this.node.fieldGroups.assign.fields.assign.value = ''
            }
            console.log('mapSelectFields:', [
                this.node.fieldGroups.status.fields.status.value,
                this.node.fieldGroups.format.fields.format.value,
                this.node.fieldGroups.author.fields.author.value,
                this.node.fieldGroups.assign.fields.assign.value
            ])
        },
        onClose() {
            this.$store.commit('client/setContentStrategy', {prop: 'isAdding', val: false});
            this.$store.commit('client/setContentStrategy', {prop: 'currentNode', val: false});
            this.$store.commit("client/resetCurrentNode");
        },
        onOpenKeywordPlannerModal() {
            console.log("Opening Keyword Planner Modal");
			this.$store.commit("client/setOpenKeywordPlannerModal", true);
		},
        updateKeyword(value) {
            console.log("Keyword set and closing modal");

            // Update keyword data
            this.$store.commit("client/setModalKeywordData", { title: value, reach: null });

            // Close the modal only if it's currently open
            if (this.$store.state.client.openKeywordPlannerModal) {
                this.$store.commit("client/setOpenKeywordPlannerModal", { prop: false, val: false });
            }

            //assign keyword value to node
            if (value !== '' && value !== null) {
                console.log('this is testing the keyword field value', value);
                this.node.fieldGroups.keyword.fields.keyword.value = value;
            }
        },
        updateFieldValue($event, fieldGroup, field, payload) {

            //let value = $event ? $event.target.value : payload
            let value = $event?.target?.value ?? payload ?? $event;

            console.log('testing value', value);

            if(field === 'assign' && value !== '' && value !== null){
                this.$store.commit("client/updateNodeFieldValue", {fieldGroup: 'status', field: 'status', value: 'Assigned'});
            }

            //assign title value to node
            if (field === 'title' && value !== '' && value !== null) {
                console.log('this is testing the title field value:', value);
                this.node.fieldGroups.title.fields.title.value = value;
            }

            //assign details value to node
            if (field === 'details' && value !== '' && value !== null) {
                console.log('this is testing the details field value:', value);
                this.node.fieldGroups.details.fields.details.value = value;
            }

            //assign keyword value to node
            if (field === 'keyword' && value !== '' && value !== null) {
                console.log('this is testing the keyword field value:', value);
                this.node.fieldGroups.keyword.fields.keyword.value = value;
            }

            if(field === 'status' && value === 'Approved' || field === 'status' && value === 'Rejected'){
                if(this.getClientData.mainContact){
                    if(this.getAuthData.username !== this.getClientData.mainContact.username){
                        alert('You must be the main contact to approve or reject');
                    }else{
                        console.log('1{fieldGroup, field, value}', [fieldGroup, field, value]);
                        this.$store.commit("client/updateNodeFieldValue", {fieldGroup, field, value})
                    }
                }else{
                    alert('main contact not set error');
                }
            }else{
                console.log('2{fieldGroup, field, value}', [fieldGroup, field, value]);
                this.$store.commit("client/updateNodeFieldValue", {fieldGroup, field, value})
            }
        },
        clearFields() {
            this.node.fieldGroups.title.fields.title.value = "";
            this.node.fieldGroups.details.fields.details.value = "";
            this.node.fieldGroups.keyword.fields.keyword.value = "";
        },
        async handleSubmit() {
            // Set formSubmitted to true when the user attempts to submit the form
            this.formSubmitted = true;

            //update and save the values
            this.node.fieldGroups.title.fields.title.value = this.fieldValue('title', 'title');
            this.node.fieldGroups.details.fields.details.value = this.fieldValue('details', 'details');
            this.node.fieldGroups.keyword.fields.keyword.value = this.fieldValue('keyword', 'keyword');

            console.log('title value:', this.fieldValue('title', 'title'));
            console.log('details value:', this.fieldValue('details', 'details'));
            console.log('keyword value:', this.fieldValue('keyword', 'keyword'));

            // Check if required fields are filled
            //const isTitleValid = !!this.node.fieldGroups.title.fields.title.value;
            const isTitleValid = !!this.fieldValue('title', 'title');
            const isFormatValid = !!this.node.fieldGroups.format.fields.format.value;

            if (!isTitleValid || !isFormatValid) {
                // Show an alert if any of the required fields are missing
                let missingFields = [];

                if (!isTitleValid) missingFields.push('Title');
                if (!isFormatValid) missingFields.push('Format');

                // Alert the user which fields are missing
                this.errorMessage = `Form submission prevented. Missing required fields: ${missingFields.join(', ')}`;
                return;
            }

            this.node.fieldGroups.status.fields.status.value = 'Title Created'

            // If validation passes, proceed with the submission
            try {
                this.mapSelectFields();
                console.log('node info', this.node);
                await this.$store.dispatch('client/createOrUpdateContentStrategyNode', {node: this.node});
                console.log('Node created/updated successfully');
                await this.$store.dispatch('client/getAllContentStrategyNodes');

                //this.$store.commit("client/resetNodeFields");
                this.$store.commit("client/resetCurrentNode");

                this.$store.commit('client/setContentStrategy', {prop: 'isAdding', val: false});

            } catch (error) {
                console.log('handleSubmit content strategy error', error);
            }
        },
    }
};
</script>

<style lang="scss">
@import "./../../../src/assets/scss/components/content-strategy.scss";

.has-error .modal-col-text input,
.has-error .modal-col-text .styled-select {
    border: 2px solid red;
}

.input-error {
    border: 2px solid red !important;
}
</style>
